import { Ads } from "@sphtech/dmg-design-system";

import { HomeAds } from "./HomeAds";
import HomeAffiliateProduct from "./HomeAffiliateProduct";
import HomeAnchorBlock from "./HomeAnchorBlock";
import HomeAnchorCarousel from "./HomeAnchorCarousel";
import HomeColumnSideScroll from "./HomeColumnSideScroll";
import HomeContentBlockA from "./HomeContentBlockA";
import HomeContentBlockB from "./HomeContentBlockB";
import HomeContentBlockD from "./HomeContentBlockD";
import HomeContentBlockF from "./HomeContentBlockF";
import HomeContentBlockG from "./HomeContentBlockG";
import HomeContentBlockGridAreas from "./HomeContentBlockGridAreas";
import HomeContentBlockI from "./HomeContentBlockI";
import HomeContentBlockJ from "./HomeContentBlockJ";
import HomeContentBlockK from "./HomeContentBlockK";
import HomeContentBlockL from "./HomeContentBlockL";
import HomeContentBlockN from "./HomeContentBlockN";
import HomeLatestStory from "./HomeLatestStory";
import HomeMagazineListing from "./HomeMagazineListing";
import HomeNewsletter from "./HomeNewsletter";
import HomeSocialVideoPortrait from "./HomeSocialVideoPortrait";
import HomeVideoGalleryLandscape from "./HomeVideoGalleryLandscape";
import HomeVideoOverlay from "./HomeVideoOverlay";

export const elementsWithoutDataSource = {
  adUnit: Ads.AdsMidContent,
  magazineListing: HomeMagazineListing,
  newsletter: HomeNewsletter,
};

export const elementsWithDataSource = {
  anchorBlock: HomeAnchorBlock,
  anchorCarousel: HomeAnchorCarousel,
  affiliateProduct: HomeAffiliateProduct,
  columnSideScroll: HomeColumnSideScroll,

  contentBlockA: HomeContentBlockA, // 5 items
  contentBlockB: HomeContentBlockB, // 3 items
  contentBlockD: HomeContentBlockD, // 3 items, Trending
  contentBlockF: HomeContentBlockF, // 3 items with IMU
  contentBlockG: HomeContentBlockG, // 4 items with IMU
  contentBlockJ: HomeContentBlockJ, // 5 items
  contentBlockK: HomeContentBlockK, // 3 items
  contentBlockL: HomeContentBlockL, // 4 or 5 items with IMU
  contentBlockN: HomeContentBlockN, // 4 items
  contentBlockI: HomeContentBlockI, // 7 or 3 items

  contentBlockGridAreas: HomeContentBlockGridAreas,

  latestArticle: HomeLatestStory,
  socialVideoPortrait: HomeSocialVideoPortrait,
  videoGalleryLandscape: HomeVideoGalleryLandscape,
  videoOverlay: HomeVideoOverlay,

  ads: HomeAds,
};
